import { apiFetch } from "../client"

export async function listBorrowerApplications(params: {
  page?: string
  per_page?: string
  status?: string
  search?: string
}) {
  const query = new URLSearchParams()
  if (params.page) query.set("page", params.page)
  if (params.per_page) query.set("per_page", params.per_page)
  if (params.status) query.set("status", params.status)
  if (params.search) query.set("search", params.search)

  return apiFetch<{
    status: string
    data: Array<any>
    meta: {
      page: number
      perPage: number
      totalItems: number
      totalPages: number
    }
  }>(`/borrower-applications?${query.toString()}`)
}

export async function getBorrowerApplication(applicationId: string) {
  return apiFetch<{ status: string; data: any }>(`/borrower-applications/${applicationId}`)
}

export async function rejectBorrowerApplication(applicationId: string, reason: string) {
  return apiFetch<{ status: string; data: any }>(
    `/borrower-applications/${applicationId}/reject`,
    {
      method: "POST",
      rawBody: { reason },
    },
  )
}

export async function convertBorrowerApplication(applicationId: string) {
  return apiFetch<{ status: string; data: any }>(
    `/borrower-applications/${applicationId}/convert`,
    {
      method: "POST",
      rawBody: {},
    },
  )
}
